//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdeKnihaPLADesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      JKLUSACEK                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-13                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvspla) GID:(Web.Set.Des.Ts) V1:(ixs_pla,rok,ico,nazev,zkratka,poznamka,aktivita,ktg_akce,dat_zmena,zmenu_prov,cpps_msk,ixp_den_old,priz_az_def,priz_gen_cis,ixs_csp,priz_ram_doh) V2:() K1:() K2:() K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdeKnihaPLADesigner
     * 
     * @author JKLUSACEK
     * @since 482.1.0.119
     */
    export class SeznamAdeKnihaPLADesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - ixs_pla */
        public ixs_pla: string;

        public rok: number;

        public ico: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdeKnihaPLAListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdeKnihaPLADesigner>, ixs_pla: string): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, ixs_pla);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction );

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdeKnihaPLADesigner>, ixs_pla: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdeKnihaPLADesigner>, ev, ctx): any {
            var filterObj = {
            }
            that.view = new Gordic.Isl.View(that.isl.AdeKnihaPLA.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdeKnihaPLADesignerInit
         * 
         * @param {GContentType<SeznamAdeKnihaPLADesigner>} that
         */
        static SeznamAdeKnihaPLADesignerInit(that: GContentType<SeznamAdeKnihaPLADesigner>, ixs_pla: string, rok: number, ico: string, withFilterPanel: boolean) {
            this.SeznamBaseInit(that);
            if (withFilterPanel == true) 
                that.filter = this.createFilter(that, ixs_pla);
            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);
            var filterObj: any = {}
            if (rok != null && rok != undefined)
                filterObj.rok = rok;
            if (ico != null && ico != undefined)
                filterObj.ico = ico;
            that.view = new Gordic.Isl.View(that.isl.AdeKnihaPLA.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem
        } // SeznamAdeKnihaPLADesignerInit


        static LoadData(that: GContentType<SeznamAdeKnihaPLADesigner>, ixs_pla: string, rok: number, ico: string) {
            var filterObj: any = {};
            if (rok != null && rok != undefined)
                filterObj.rok = rok;
            if (ico != null && ico != undefined)
                filterObj.ico = ico;
            that.view = new Gordic.Isl.View(that.isl.AdeKnihaPLA.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false })
        }
    }
}
